<template>
    <BModal ref="editInterventionModal" :title="$t('interventions.modal.editTitle')" centered no-close-on-backdrop header-variant="primary" modal-class="no-border-modal">
        <form v-if="intervention" class="modal-content" id="editInterventionForm" @submit.prevent="handleSubmit">
            <div class="mb-3">
                <label class="form-label">{{ $t('interventions.modal.validityStart') }}</label>
                <VueDatePicker
                    v-model="intervention.validity_start"
                    :locale="$i18n.locale"
                    :enable-time-picker="true"
                    format="dd/MM/yyyy HH:mm"
                    :placeholder="$t('interventions.modal.datePlaceholder')"
                    :select-text="$t('interventions.modal.datePickerSelect')"
                    :cancel-text="$t('interventions.modal.datePickerCancel')"
                    required
                />
            </div>
            <div class="mb-3">
                <label class="form-label">{{ $t('interventions.modal.validityEnd') }}</label>
                <VueDatePicker
                    v-model="intervention.validity_end"
                    :locale="$i18n.locale"
                    :enable-time-picker="true"
                    format="dd/MM/yyyy HH:mm"
                    :placeholder="$t('interventions.modal.datePlaceholder')"
                    :select-text="$t('interventions.modal.datePickerSelect')"
                    :cancel-text="$t('interventions.modal.datePickerCancel')"
                    required
                />
            </div>
            <div class="mb-3">
                <label class="form-label">{{ $t('interventions.modal.note') }} <span class="text-muted">{{ $t('interventions.modal.optional') }}</span></label>
                <textarea class="form-control" v-model="intervention.note" rows="2" :placeholder="$t('interventions.modal.notePlaceholder')"></textarea>
            </div>
        </form>
        <template #footer="{ cancel }">
            <div v-if="canUpdateIntervention" class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('interventions.modal.cancel') }}</button>
                <span v-if="errorMessage" class="flex-grow-1 mx-3 text-center custom-error-msg">{{ errorMessage }}</span>
                <button type="submit" class="btn btn-primary" form="editInterventionForm">{{ $t('interventions.modal.save') }}</button>
            </div>
            <div v-else class="justify-content-end align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('interventions.modal.cancel') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import { useI18n } from 'vue-i18n';
import { showToast } from '@/services/toast';
import { BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';

export default {
    name: 'EditInterventionModal',
    components: {
        BModal,
    },
    emits: ['updated'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const userStore = useUserStore();
        const editInterventionModal = ref(null);
        const errorMessage = ref('');
        const intervention = ref(null);
        const canUpdateIntervention = ref(false);

        const show = (inter) => {
            intervention.value = inter.clone();
            canUpdateIntervention.value = !inter.is_external;
            errorMessage.value = '';
            editInterventionModal.value.show();
        };

        const hide = () => {
            editInterventionModal.value.hide();
        };

        const handleSubmit = async () => {
            try {
                const updated = await userStore.updateIntervention(intervention.value);
                hide();
                showToast('success', t('interventions.modal.updated'));
                emit('updated', updated);
            } catch (error) {
                errorMessage.value = error;
            }
        };

        return {
            handleSubmit,
            errorMessage,
            editInterventionModal,
            intervention,
            show,
            hide,
            canUpdateIntervention,
        };
    },
};
</script>

<style>
.no-border-modal .modal-header {
  border-bottom: none !important;
}

.no-border-modal .modal-footer {
  border-top: none !important;
}
</style>
